import { centsToDollarFormat } from '../../../../../../shared/utils/general';
import { convertDecimalToPercentile } from '../../../../../workflow/utils/transformFuncs';

export function getDetailValue(
  amount: number | undefined,
  percent: boolean | undefined,
): string {
  if (percent && amount) {
    return `${convertDecimalToPercentile(amount)}%`;
  }

  if (amount || amount === 0) {
    return centsToDollarFormat(amount);
  }

  return '-';
}
